import { useState } from "react";
import { Loading } from "./";
import {
  Button,
  Card,
  CardBody,
  Row,
  Col,
  ButtonGroup,
  Collapse
} from "reactstrap";
import _ from 'lodash';

const FilterSearch = (props) => {
  const [advSearchOpen, setAdvSearchOpen] = useState(false);

  let filterDisplay = '';
  const filters = props.filters && _.isArray(props.filters)
      ? props.filters
      : [];
  if (filters.length && advSearchOpen) {
    filterDisplay = _.chain(filters)
      .filter(x => x.value || x.startDate || x.endDate)
      .map(x => x.filteredDisplay)
      .reject(x => !x)
      .value()
      .join(" | ");
  }
  return (
    <div className="p-2">
      <div className="d-flex w-100 justify-content-end">
        <Button
          color="dark"
          size="sm"
          onClick={() => setAdvSearchOpen(!advSearchOpen)}
        >
          {advSearchOpen ? "Hide Advanced Search" : "Show Advanced Search"}
        </Button>
      </div>
      <Collapse isOpen={advSearchOpen}>
        {props.isLoading
          ? (<Loading />)
          : (<Card id="advSearch" className="bg-light mb-2">
              <CardBody>
                <Row>
                  {props.children}
                </Row>
                <Row className={'mt-2 d-flex justify-content-between '}>
                  <Col>
                    <span className="filter-display">{filterDisplay}</span>
                  </Col>
                  <Col sm={3}>
                    <ButtonGroup className={'float-end'}>
                      <Button color="dark" disabled={filters.length ? false : true} onClick={props.onClear}>
                        Clear Criteria
                      </Button>
                    </ButtonGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>)
        }
      </Collapse>
    </div>
  );
};

export default FilterSearch;